import { useEffect, useState } from 'react';
import {
  nextTeacherWaitingIndex,
  teacherWaitingCount,
  teacherWaitingLine,
} from './teacher-waiting';

/** Délai entre deux phrases du prof (ms). */
export const TEACHER_WAITING_INTERVAL_MS = 2800;

/**
 * Sous la question, réponse envoyée : « Le prof relève 3 copies… », qui change au hasard en attendant le résultat.
 */
export function TeacherWaitingNote({ copies }: { copies: number | null }) {
  const count = teacherWaitingCount(copies);
  const [index, setIndex] = useState(() => Math.floor(Math.random() * count));

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((prev) => nextTeacherWaitingIndex(prev, Math.random(), count));
    }, TEACHER_WAITING_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [count]);

  return (
    <p className="pp-teacher-waiting" aria-live="polite" data-testid="teacher-waiting">
      {teacherWaitingLine(index, copies)}
    </p>
  );
}
